import { useEffect, useMemo, useState } from "react";
import { api } from "../../lib/api";
import AdminLayout from "./AdminLayout";

export default function AdminDestinations() {
    const [rows, setRows] = useState([]);
    const [q, setQ] = useState("");
    const [sort, setSort] = useState("times_saved");

    useEffect(() => {
        api.get("/admin/destinations").then((r) => setRows(r.data.destinations)).catch(() => {});
    }, []);

    const filtered = useMemo(() => {
        const lower = q.trim().toLowerCase();
        const list = !lower ? rows : rows.filter((r) =>
            (r.city || "").toLowerCase().includes(lower) ||
            (r.country || "").toLowerCase().includes(lower) ||
            (r.planet || "").toLowerCase().includes(lower));
        return [...list].sort((a, b) => (b[sort] || 0) - (a[sort] || 0));
    }, [rows, q, sort]);

    return (
        <AdminLayout title="Destination Analytics" subtitle={`${rows.length} destinations · engagement summary`}>
            <div className="flex flex-wrap gap-3 items-center mb-4">
                <input className="sp-input flex-1 min-w-[220px]" placeholder="Search city, country, planet…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-destinations-search" />
                <select className="sp-input" value={sort} onChange={(e) => setSort(e.target.value)} data-testid="admin-destinations-sort">
                    <option value="times_saved">Most Saved</option>
                    <option value="times_recommended">Most Recommended</option>
                    <option value="flight_searches">Most Flight-Searched</option>
                    <option value="avg_compatibility_score">Highest Compatibility</option>
                </select>
            </div>

            <div className="bg-surface border border-ink/10 rounded-2xl overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b border-ink/10 text-xs text-ink-muted uppercase tracking-wider">
                                <th className="text-left px-3 py-3">Destination</th>
                                <th className="text-left px-3 py-3">Planet</th>
                                <th className="text-right px-3 py-3">Recommended</th>
                                <th className="text-right px-3 py-3">Saved</th>
                                <th className="text-right px-3 py-3">Flight Searches</th>
                                <th className="text-right px-3 py-3">Avg Score</th>
                            </tr>
                        </thead>
                        <tbody data-testid="admin-destinations-tbody">
                            {filtered.map((r) => (
                                <tr key={r.destination_id} className="border-b border-ink/5">
                                    <td className="px-3 py-3">
                                        <div className="font-medium">{r.city}</div>
                                        <div className="text-xs text-ink-muted">{r.country}</div>
                                    </td>
                                    <td className="px-3 py-3 capitalize">{r.planet || "—"}</td>
                                    <td className="px-3 py-3 text-right tabular-nums">{r.times_recommended}</td>
                                    <td className="px-3 py-3 text-right tabular-nums">{r.times_saved}</td>
                                    <td className="px-3 py-3 text-right tabular-nums">{r.flight_searches}</td>
                                    <td className="px-3 py-3 text-right tabular-nums">{r.avg_compatibility_score || "—"}</td>
                                </tr>
                            ))}
                            {filtered.length === 0 && (
                                <tr><td colSpan={6} className="px-3 py-10 text-center text-ink-muted text-sm">No destinations match.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    );
}
